import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-custom-header',
    templateUrl: './custom-header.component.html',
    styleUrls: ['./custom-header.component.scss'],
    standalone: false
})
export class CustomHeaderComponent {
  @Input() header!: string;
  @Input() subHeader?: string;
}